import type {FailedQuestionData} from "app/employee/state/syllabus/selectors";
import {FailedQuestion} from "app/employee/test/result/FailedQuestion";
import {IonGrid} from "@ionic/react";

interface Props {
  failedQuestions: FailedQuestionData[];
  showAnswer?: boolean;
}

export const FailedQuestions = ({failedQuestions, showAnswer}: Props) => {
  return (
    <IonGrid>
      {failedQuestions.map((failedQuestion) => {
        return (
          <FailedQuestion failedQuestion={failedQuestion} key={failedQuestion.question.id} showAnswer={showAnswer} />
        );
      })}
    </IonGrid>
  );
};
